export default __webpack_public_path__ + "static/media/a10.ff6e7720.png";